<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="cus-note"></i>
                    Notes
                </template>

                <b-dropdown-item @click="loadList('NOTES')">
                    <i class="cus-note"></i>View Notes
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="isMobileExtensionEnabled"
                    @click="loadList('PETCARE_NOTES')"
                >
                    <i class="cus-note"></i>View PetCare Notes
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="isMobileExtensionEnabled"
                    @click="loadList('PETCARE_LOGS')"
                >
                    <i class="cus-note"></i>View PetCare Logs
                </b-dropdown-item>

                <div
                    class="dropdown-divider"
                    v-if="_hasAccess('patient.precaution.create')"
                ></div>

                <b-dropdown-item
                    v-if="_hasAccess('patient.precaution.create')"
                    @click.stop="addNote()"
                >
                    <i class="cus-add"></i> New Note
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <list-petcare-notes
                v-if="selectedOption == 'PETCARE_NOTES'"
                :key="componentKey"
                :patientId="patientId"
            />
            <list-petcare-logs
                v-if="selectedOption == 'PETCARE_LOGS'"
                :key="componentKey"
                :patientId="patientId"
            />
            <list-notes
                v-if="selectedOption == 'NOTES'"
                :key="componentKey"
                :patientId="patientId"
            />
        </b-card-text>
    </b-tab>
</template>
<script>
import EXTENSIONS from "@/constants/extensions";

export default {
    components: {
        ListNotes: () => import("@/components/patient-notes/note-list"),
        ListPetcareNotes: () =>
            import("@/components/patient-notes/petcare-note-list"),
        ListPetcareLogs: () =>
            import("@/components/patient-notes/petcare-log-list")
    },
    props: {
        patientDetails: {
            type: Object
        }
    },
    data() {
        return {
            componentKey: 0,
            selectedOption: "NOTES"
        };
    },
    computed: {
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        statusInActive() {
            return this.$store.getters["patient/statusInActive"];
        },
        isMobileExtensionEnabled() {
            return this._isExtensionEnabled(
                EXTENSIONS.CODE.CODE_CLIENT_MOBILE_APP
            );
        }
    },
    methods: {
        loadList(code) {
            this.selectedOption = code;
            this.componentKey += 1;
        },
        addNote() {
            this.$parent.$parent.$refs.modalNewNote.open();
        }
    }
};
</script>
